import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {NgForm} from '@angular/forms';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;

@Component({
  selector: 'app-add-driver',
  templateUrl: './add-driver.component.html',
  styleUrls: ['./add-driver.component.css']
})
export class AddDriverComponent implements OnInit {
  nao = new Nanobar();
  countryCode: any;
  numChk = false;
  maxYear: any;
  btnDisable = false;
  first_name: any;
  last_name: any;
  phone: any;
  email: any;
  dob: any;
  address_line1: any;
  address_line2: any;
  street: any;
  city: any;
  state: any;
  zip: any;
  area: any;
  note: any;
  addDriverData: any;
  driving_license_front: any;
  driving_license_back: any;
  registration_book: any;
  success: any;
  addDriver = false;
  place: any;
  error_count: any;
  emailChk: any;
  latitude: any;
  longitude: any;
  clearTimeout: any;
  placeSuggestionsData: any;
  placeDetailData: any;
  placeDataFound = false;
  addressLoad = false;
  private today = new Date();
  selDate: any;
  selectAddress = false;
   myDatePickerOptions: IMyDpOptions = {
        // other options...
        dateFormat: 'mm/dd/yyyy',
         showTodayBtn: true,
        todayBtnTxt: 'Today',
        showClearDateBtn: false,
        indicateInvalidDate: true,
        editableDateField: false,
        openSelectorOnInputClick: true,
        disableSince: {year: this.today.getFullYear() - 20, month: 1, day: 1},
        // minYear: this.today.getFullYear() - 20,
        // disableSince: {year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() + 1}
        // disableUntil: {year: 0, month: 0, day: 0}
    };
  constructor(private dataService: DataService, private cs: CountryService, private router: Router) {
    this.dataService.pageName = 'add driver';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
    setTimeout(() => {
    this.maxYear = new Date().getFullYear();
    this.maxYear = parseInt(this.maxYear, 10) - 21;
    this.selDate = '01/01/' + this.maxYear;
    this.dob = this.selDate;
    }, 1500);
  }

  addDriverFunction(form: NgForm) {
    this.error_count = 0;
    $('.c-label label').css('color', '#3d3e3d');
     $('.uploadText').css('color', '#3d3e3d');
     $('.c-label input').css('border-color', '#ccc');
     $('.c-label textarea').css('border-color', '#ccc');
    this.addDriver = true;
    console.log('login data');
    // this.dob = $('#datepicker').val();
    var formatted_date = this.dob.formatted;
    console.log('this.dob', this.dob);
    this.city = $('#city').val();
    this.zip = $('#zip').val();
    this.state = $('#state').val();
    this.area = $('#area').val();
    this.address_line1 = $('#c-address input').val();
    console.log('chk images', this.driving_license_front, this.driving_license_back, this.registration_book );
     if (this.driving_license_front === undefined) {
              $('#c-front label').css('color', '#a10a0d');
              this.error_count ++;
      }
      if (this.driving_license_back === undefined) {
            $('#c-back label').css('color', '#a10a0d');
            this.error_count ++;
      }
      if (this.registration_book === undefined) {
            $('#c-registration label').css('color', '#a10a0d');
            this.error_count ++;
      }
      if (this.first_name === '' || this.first_name === undefined) {
                  $('#c-fname label').css('color', '#a10a0d');
                  $('#c-fname input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.last_name === '' || this.last_name === undefined) {
                  $('#c-lname label').css('color', '#a10a0d');
                  $('#c-lname input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.phone === '' || this.phone === undefined || this.numChk === true) {
                  $('#c-phone label').css('color', '#a10a0d');
                  $('#c-phone input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.dob === '' || this.dob === undefined) {
                  $('#c-dob label').css('color', '#a10a0d');
                  $('#c-dob input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      // this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // if (!this.emailChk.test(this.email) && this.email !== '') {
      //             $('#c-email label').css('color', '#a10a0d');
      //             $('#c-email input').css('border-color', '#a10a0d');
      //             this.error_count ++;
      // }
      if (this.address_line1 === '' || this.address_line1 === undefined) {
                  $('#c-address label').css('color', '#a10a0d');
                  $('#c-address input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      // if (this.address_line2 === '' || this.address_line2 === undefined) {
      //             $('#c-address2 label').css('color', '#a10a0d');
      //             $('#c-address2 input').css('border-color', '#a10a0d');
      //             this.error_count ++;
      // }
      if (this.city === '' || this.city === undefined) {
                  $('#c-city label').css('color', '#a10a0d');
                  $('#c-city input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      if (this.zip === '' || this.zip === undefined) {
                  $('#c-zip label').css('color', '#a10a0d');
                  $('#c-zip input').css('border-color', '#a10a0d');
                  this.error_count ++;
      }
      // if (this.state === '' || this.state === undefined) {
      //             $('#c-state label').css('color', '#a10a0d');
      //             $('#c-state input').css('border-color', '#a10a0d');
      //             this.error_count ++;
      // }
      // if (this.area === '' || this.area === undefined) {
      //             $('#c-area label').css('color', '#a10a0d');
      //             $('#c-area input').css('border-color', '#a10a0d');
      //             this.error_count ++;
      // }
      // if (this.note === '' || this.note === undefined) {
      //             $('#c-note label').css('color', '#a10a0d');
      //             $('#c-note input').css('border-color', '#a10a0d');
      //             this.error_count ++;
      // }
      if (this.error_count > 0) {
        return;
      }
       if (this.email !== '' && this.email !== undefined && this.email !== null) {
      this.emailChk = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.emailChk.test(this.email)) {
                  $('#c-email label').css('color', '#a10a0d');
                  $('#c-email input').css('border-color', '#a10a0d');
                  // this.error_count ++;
        toastr.error('Please Enter a valid email');
        return;
      }
      }
       if (this.latitude === undefined || this.latitude === '' || this.longitude === undefined || this.longitude === '' ) {
        toastr.error('Please Update the address & select it from Google suggestions for accuracy');
        return;
      }
      var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
      // this.phone = '+' + getCode + this.phone;
      var phone_number = '+' + getCode + this.phone;
      console.log('number', this.phone);
    this.btnDisable = true;
    this.nao.go(30);
    this.dataService.addDriver(window.localStorage.getItem('token'),
      this.first_name, this.last_name, phone_number,
      this.email, formatted_date, this.address_line1, this.street, this.address_line2, this.city,
      this.zip, this.state, this.area, this.note, this.driving_license_front,
      this.driving_license_back, this.registration_book, this.latitude, this.longitude).subscribe(
      (data) => {
        console.log('outlet data');
        this.nao.go(100);
        this.addDriverData = data;
         if (this.addDriverData.rest_error_code === 1) {
          toastr.error('Some thing went wrong');
          this.btnDisable = false;
        }
        if (this.addDriverData.rest_error_code === 2) {
          toastr.error('Please login again');
          this.btnDisable = false;
        }
        if (this.addDriverData.rest_error_code === 3) {
          toastr.error('Driver already exists');
          this.btnDisable = false;
        }
        if (this.addDriverData.rest_error_code === 4) {
          toastr.error('Driver does not exist');
          this.btnDisable = false;
        }
        this.success = data;
        this.success = this.success.success;
        if (this.success === true) {
          toastr.success('Driver added successfully');
          this.router.navigate(['drivers']);
          this.btnDisable = false;
        }
        if (this.success === false) {
          this.addDriver = false;
          this.btnDisable = false;
        }
      },
      (error) => {
        this.addDriver = false;
        this.btnDisable = false;
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }

   // addressDetail() {
   //  this.street = '';
   //  console.log('chk address detail', this.place);
   //     for(var i = 0; i < this.placeDetailData.length; i++) {
   //    for(var j = 0; j < this.placeDetailData[i].types.length; j++) {
   //      // if (this.place.address_components[i].types[j] === 'administrative_area_level_2') {
   //      //   // this.city = this.place.address_components[i].long_name;
   //      //   // console.log('city', this.city);
   //      //    $('#city').val(this.place.address_components[i].long_name);
   //      // }
   //      if (this.place.address_components[i].types[j] === 'locality') {
   //        // this.city = this.place.address_components[i].long_name;
   //        // console.log('city', this.city);
   //         $('#city').val(this.place.address_components[i].long_name);
   //      }
   //       if (this.place.address_components[i].types[j] === 'street_number') {
   //        this.street = this.place.address_components[i].long_name;
   //        console.log('street number', this.street);
   //      }
   //      if (this.place.address_components[i].types[j] === 'route') {
   //        this.street = this.street + ' ' + this.place.address_components[i].long_name;
   //        console.log('route', this.street);
   //      }
   //      if (this.place.address_components[i].types[j] === 'sublocality_level_2') {
   //        this.street = this.street + ' ' + this.place.address_components[i].long_name;
   //        console.log('sublocality 2', this.street);
   //      }
   //      if (this.place.address_components[i].types[j] === 'sublocality_level_1') {
   //        this.street = this.street + ' ' + this.place.address_components[i].long_name;
   //        console.log('sublocality 1', this.street);
   //      }
   //      if (this.place.address_components[i].types[j] === 'administrative_area_level_1') {
   //        // this.state = this.place.address_components[i].long_name;
   //        $('#state').val(this.place.address_components[i].short_name);
   //      }
   //
   //      if (this.place.address_components[i].types[j] === 'country') {
   //        // this.area = this.place.address_components[i].long_name;
   //        $('#area').val(this.place.address_components[i].long_name);
   //      }
   //
   //      if (this.place.address_components[i].types[j] === 'postal_code') {
   //        // this.zip = this.place.address_components[i].long_name;
   //        $('#zip').val(this.place.address_components[i].long_name);
   //      } else {
   //          $('#zip').val('');
   //      }
   //      this.latitude = this.place.geometry.location.lat();
   //        this.longitude = this.place.geometry.location.lng();
   //
   //      }
   //    }
   //  }

  // inputAddress1() {
  //   var context = this;
  //   console.log('inputAddress');
  //
  //   const input = document.getElementById('searchTextField3');
  //
  //   const searchBox = new google.maps.places.Autocomplete(input);
  //   searchBox.addListener('place_changed', function() {
  //
  //     console.log('place changed');
  //     context.place = searchBox.getPlace();
  //     console.log('address', context.place);
  //     context.addressDetail();
  //
  //   });
  // }
  // inputAddress2() {
  //
  //   const input2 = document.getElementById('searchTextField4');
  //
  //   const searchBox2 = new google.maps.places.Autocomplete(input2);
  //   searchBox2.addListener('place_changed', function() {
  //
  //     console.log('place changed');
  //     const place = searchBox2.getPlace();
  //     console.log('address', place);
  //
  //   });
  // }
  restrictUserInput($event) {
    $event.preventDefault();
  }
 countryValidation() {
    var code = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    code = '+' + code;
    var val = $('#phoneValue').val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        // console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          console.log('valid');
          this.numChk = false;
          $('#phoneValue').css('border-color', '#ccc');
        } else {
          console.log('invalid');
          this.numChk = true;
          $('#phoneValue').css('border-color', '#eb3b3b');
        }
      }
    }
  }
  prevent($event) {
   console.log('prevent default', $event.keyCode);
   if ($event.keyCode === 8 || $event.keyCode === 46) {
      return;
    }
   if (!($event.keyCode >= 48 && $event.keyCode <= 57)) {
      $event.preventDefault();
      return;
    }
 }
 capitlizeFirstName() {
    this.first_name = this.first_name.replace(/\b\w/g, function(l){ return l.toUpperCase()});
  }
  capitlizeLastName() {
    this.last_name = this.last_name.replace(/\b\w/g, function(l){ return l.toUpperCase()});
  }
   addressDetail() {
     $('#state').val('');
    this.street = '';
    console.log('chk address detail', this.place);
       for(var i = 0; i < this.placeDetailData.length; i++) {
      for(var j = 0; j < this.placeDetailData[i].types.length; j++) {
        if (this.placeDetailData[i].types[j] === 'administrative_area_level_2') {
           $('#city').val(this.placeDetailData[i].long_name);
        }
        else if (this.placeDetailData[i].types[j] === 'locality') {
          // this.city = this.place.address_components[i].long_name;
          // console.log('city', this.city);
           $('#city').val(this.placeDetailData[i].long_name);
        }
         if (this.placeDetailData[i].types[j] === 'street_number') {
          this.street = this.placeDetailData[i].long_name;
          console.log('street number', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'route') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('route', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_2') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 2', this.street);
        }
        if (this.placeDetailData[i].types[j] === 'sublocality_level_1') {
          this.street = this.street + ' ' + this.placeDetailData[i].long_name;
          console.log('sublocality 1', this.street);
        }
        //   this.street = this.place.name;
        //   console.log('this.street', this.street);

        if (this.placeDetailData[i].types[j] === 'administrative_area_level_1') {
          $('#state').val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === 'country') {
          // this.area = this.place.address_components[i].long_name;
          $('#area').val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === 'postal_code') {
          // this.zip = this.place.address_components[i].long_name;
          console.log('postal; code', this.placeDetailData[i].long_name);
          $('#zip').val(this.placeDetailData[i].long_name);
        } else {
            $('#zip').val('');
        }
        }
      }
    }
    functionTogetPlace () {
      if ( this.selectAddress === true ) {
        return;
      }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      // this.addressLoad = true;
     this.dataService.googleAddress(this.address_line1).subscribe(
      (data) => {
        this.placeSuggestionsData = data;
        this.placeSuggestionsData = this.placeSuggestionsData.predictions;
        console.log('place google data', this.placeSuggestionsData);
        this.placeDataFound = true;
        if ($('.myDrop').hasClass('open')) {

        } else {
          $('.myDrop').addClass('open');
        }
        // this.addressLoad = false;
        // $('#searchTextField').click();
        // $('#searchTextField').focus();
      },
      (error) => {
      }
    );
     }, 1000);
  }
  functionTogetPlaceDetail (name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
     this.dataService.googleAddressDetail(id).subscribe(
      (data) => {
        console.log('place google detail data', data);
        this.placeDetailData = data;
        this.selectAddress = true;
        this.placeDetailData = this.placeDetailData.result;
        this.latitude = this.placeDetailData.geometry.location.lat;
        this.longitude = this.placeDetailData.geometry.location.lng;
        console.log('this.latitude', this.latitude);
        console.log('this.longitude', this.longitude);
        this.placeDetailData = this.placeDetailData.address_components;
        this.callMap();
        setTimeout(() => {
          this.addressDetail();
          this.addressLoad = false;
        }, 1000);
      },
      (error) => {
      }
    );
     }, 1000);
  }

  callMap(){
    setTimeout(() => {
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng( this.latitude , this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 20,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
        // mapTypeControl: false,
        // disableDefaultUI: true
      };
      var endImage = {
        url: 'assets/pin.png', // url
        scaledSize: new google.maps.Size(20, 32), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(10, 35) // anchor
      };
      map = new google.maps.Map(document.getElementById('myMap'), mapOptions);
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        draggable: true,
        icon: endImage,
      });
      geocoder.geocode({'latLng': myLatlng }, function(results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            // $('#address').val(results[0].formatted_address);
            // $('#latitude').val(marker.getPosition().lat());
            // $('#longitude').val(marker.getPosition().lng());
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude = marker.getPosition().lat();
            context.longitude = marker.getPosition().lng();
            console.log( context.latitude, context.longitude);
            console.log('results', results);
            // context.getDeliveryAddressDetail(results[0]);

          }
        }
      });


      google.maps.event.addListener(marker, 'dragend', function() {
        geocoder.geocode({'latLng': marker.getPosition()}, function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              infowindow.setContent(results[0].formatted_address);
              infowindow.open(map, marker);
              context.latitude = marker.getPosition().lat();
              context.longitude = marker.getPosition().lng();
              // context.addressNew =  results[0].formatted_address;
              console.log( context.latitude, context.longitude);
              console.log('results', results);
              // this.changeRef.detectChanges();
              // context.getDeliveryAddressDetail(results[0]);
            }
          }
        });
      });
    }, 500);
  }
  resetAddress(){
    this.address_line1 = '';
    // this.address_line2 = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.area = '';
    // this.apart = '';
    this.longitude = '';
    this.latitude = '';
    this.selectAddress = false;
  }
  ngOnInit() {
    // this.inputAddress1();
    // this.inputAddress2();
    $(function() {
      this.maxYear =new Date().getFullYear();
        this.maxYear = parseInt(this.maxYear) - 21;
      $('#datepicker').datepicker({
        format: 'mm/dd/yyyy', // Notice the Extra space at the beginning
        defaultDate:'-10d',
        endDate: new Date('12/31/'+ this.maxYear)
      });
        $('#phone').intlTelInput({
        // autoFormat: true,
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss',
        autoPlaceholder: false,
        preferredCountries: ['GB'],
        preventInvalidNumbers: true,
        // stop the user from typing invalid dial codes
        preventInvalidDialCodes: true,
        formatOnDisplay: true,
        separateDialCode: false,
      });
      var countryCode;
       setTimeout(() => {
        countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
        $('#phone').val('+' + countryCode);
       }, 1000);
        $('#phone').change(
                function () {
                     countryCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
                    $('#phone').val('+' + countryCode);

                }
            );
    });

    var context = this;
    $(function () {
      $('#front').change(function () {

        console.log('image change', this.files[0]);
        if (this.files && this.files[0]) {
          var reader = new FileReader();
          // this.driving_license_front = this.files[0];
          // console.log('file 1 front cover chk', this.driving_license_front);
          reader.onload = (function(file) {
            context.driving_license_front = file.target;
            context.driving_license_front = context.driving_license_front.result;
            console.log('base 64 1 image chk', context.driving_license_front);
            return imageIsLoadedFront(file);
          });
          reader.readAsDataURL(this.files[0]);
        }
      });

      $('#back').change(function () {
        console.log('image change',this.files[0]);
        if (this.files && this.files[0]) {
          var reader2 = new FileReader();
          // context.uploadImageFunction(this.files[0]);
          reader2.onload = (function(file) {
            context.driving_license_back = file.target;
            context.driving_license_back = context.driving_license_back.result;
            console.log('base 64 2 image chk', context.driving_license_back);
            return imageIsLoadedBack(file);
          });
          reader2.readAsDataURL(this.files[0]);
        }
      });

      $('#registration').change(function () {

        console.log('image change',this.files[0]);
        if (this.files && this.files[0]) {
          var reader3 = new FileReader();
          // context.uploadImageFunction(this.files[0]);
          reader3.onload = (function(file) {
            context.registration_book = file.target;
            context.registration_book = context.registration_book.result;
            console.log('base 64 3 image chk', context.registration_book);
            return imageIsLoadedRegister(file);
          });
          reader3.readAsDataURL(this.files[0]);
        }
      });

    });

    function imageIsLoadedFront(e) {
      $('#pImg1').attr('src', e.target.result);
    }
    function imageIsLoadedBack(e) {
      $('#pImg2').attr('src', e.target.result);
    }
    function imageIsLoadedRegister(e) {
      $('#pImg3').attr('src', e.target.result);
    }

    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#driver').css('color', '#d77229');
  }

}



// WEBPACK FOOTER //
// ./src/app/add-driver/add-driver.component.ts